// Auto-generated by `npm run design:manifest`. Do not edit manually.
export const designAssetManifest = {
  "mobile/bg@2x-80.jpg": true,
  "mobile/booking.svg": true,
  "mobile/ig1.png": true,
  "mobile/ig10.jpg": true,
  "mobile/ig11.jpg": true,
  "mobile/ig12.jpg": true,
  "mobile/ig13.jpg": true,
  "mobile/ig14.jpg": true,
  "mobile/ig15.jpg": true,
  "mobile/ig16.jpg": true,
  "mobile/ig17.jpg": true,
  "mobile/ig18.jpg": true,
  "mobile/ig19.jpg": true,
  "mobile/ig2.png": true,
  "mobile/ig20.jpg": true,
  "mobile/ig21.jpg": true,
  "mobile/ig22.jpg": true,
  "mobile/ig23.png": true,
  "mobile/ig24.png": true,
  "mobile/ig25.png": true,
  "mobile/ig26.png": true,
  "mobile/ig27.png": true,
  "mobile/ig28.png": true,
  "mobile/ig29.png": true,
  "mobile/ig3.png": true,
  "mobile/ig30.png": true,
  "mobile/ig4.jpg": true,
  "mobile/ig5.png": true,
  "mobile/ig6.jpg": true,
  "mobile/ig7.png": true,
  "mobile/ig8.jpg": true,
  "mobile/ig9.jpg": true,
  "mobile/leftIcon.png": true,
  "mobile/rightIcon.png": true,
  "mobile/交通路线.png": true,
  "mobile/休闲娱乐.svg": true,
  "mobile/参观须知.png": true,
  "mobile/图说达古.svg": true,
  "mobile/在线直播.svg": true,
  "mobile/导览地图.png": true,
  "mobile/温馨住宿.svg": true,
  "mobile/游玩攻略.svg": true,
  "mobile/精品线路.svg": true,
  "mobile/精致特产.svg": true,
  "mobile/美食推荐.svg": true,
  "mobile/路线推荐.png": true,
  "pc/1-7-2.jpg": true,
  "pc/10-9-4.jpg": true,
  "pc/10-9-5.jpg": true,
  "pc/640.png": true,
  "pc/9-3_4.jpg": true,
  "pc/accommodation@2x-8.png": true,
  "pc/activity-1@2x-8.png": true,
  "pc/activity-2-hover@2x-8.png": true,
  "pc/activity-3@2x-8.png": true,
  "pc/activity-4@2x-8.png": true,
  "pc/bgTitle.png": true,
  "pc/bgYunyou-text.png": true,
  "pc/bgYunyou.jpg": true,
  "pc/bingchuan1.png": true,
  "pc/bingchuan2.png": true,
  "pc/boutique-route@2x-8.png": true,
  "pc/carRoute.jpg": true,
  "pc/daguer/1.png": true,
  "pc/daguer/2.png": true,
  "pc/daguer/3.png": true,
  "pc/flight-route@2x-8.png": true,
  "pc/floating-bar@2x-8.png": true,
  "pc/food@2x-8.png": true,
  "pc/g4.jpg": true,
  "pc/gftj/accommodation.svg": true,
  "pc/gftj/accommodation@2x-80.jpg": true,
  "pc/gftj/boutique-route.svg": true,
  "pc/gftj/boutique-route@2x-80.jpg": true,
  "pc/gftj/food.svg": true,
  "pc/gftj/food@2x-80.jpg": true,
  "pc/gftj/leisure.svg": true,
  "pc/gftj/leisure@2x-80.jpg": true,
  "pc/gftj/specialty.svg": true,
  "pc/gftj/specialty@2x-80.jpg": true,
  "pc/gftj/travel-guide.svg": true,
  "pc/gftj/travel-guide@2x-80.jpg": true,
  "pc/glacier-blanket-1@2x-8.png": true,
  "pc/glacier-blanket-2@2x-8.png": true,
  "pc/glacier-exp-1-1@2x-8.png": true,
  "pc/glacier-exp-1@2x-8.png": true,
  "pc/highway-route@2x-8.png": true,
  "pc/homeLog.png": true,
  "pc/ig1.jpg": true,
  "pc/ig2.jpg": true,
  "pc/ig3.jpg": true,
  "pc/ig3.png": true,
  "pc/ig4.jpg": true,
  "pc/ig5.jpg": true,
  "pc/image-1@2x-8.png": true,
  "pc/image-2-1@2x-8.png": true,
  "pc/image-2@2x-8.png": true,
  "pc/image-3@2x-8.png": true,
  "pc/jqtg/chun.jpg": true,
  "pc/jqtg/dong.jpg": true,
  "pc/jqtg/qiu.jpg": true,
  "pc/jqtg/xia.jpg": true,
  "pc/landscape@2x-8.png": true,
  "pc/leisure@2x-8.png": true,
  "pc/live-video@2x-8.png": true,
  "pc/marketing-campaign.jpg": true,
  "pc/open-time-1@2x-80.jpg": true,
  "pc/open-time-2@2x-80.jpg": true,
  "pc/open-time@2x-8.png": true,
  "pc/qr-code.png": true,
  "pc/rail-route@2x-8.png": true,
  "pc/real-time-weather@2x-8.png": true,
  "pc/s-home-1-text.png": true,
  "pc/s-home-1.jpg": true,
  "pc/s-home-title.png": true,
  "pc/scenic-altitude@2x-8.png": true,
  "pc/scenic-guide@2x-8.png": true,
  "pc/scenicAreaGuide.png": true,
  "pc/shiyan1.png": true,
  "pc/shiyan2.png": true,
  "pc/specialty@2x-8.png": true,
  "pc/SVG/accommodation-title.png": true,
  "pc/SVG/activity-active@2x-8.png": true,
  "pc/SVG/activity-normal@2x-8.png": true,
  "pc/SVG/activity-text-bg@2x-8.png": true,
  "pc/SVG/altitude-active.svg": true,
  "pc/SVG/altitude.svg": true,
  "pc/SVG/back-to-top.svg": true,
  "pc/SVG/bg1.png": true,
  "pc/SVG/bg2.png": true,
  "pc/SVG/bg3.png": true,
  "pc/SVG/blue-location.svg": true,
  "pc/SVG/booking-active.svg": true,
  "pc/SVG/booking.svg": true,
  "pc/SVG/boutique-route-title.svg": true,
  "pc/SVG/bus.png": true,
  "pc/SVG/cableway-remaining.svg": true,
  "pc/SVG/consult-active.svg": true,
  "pc/SVG/consult.svg": true,
  "pc/SVG/douyin.svg": true,
  "pc/SVG/floating-bar.png": true,
  "pc/SVG/footer-glacier@3.png": true,
  "pc/SVG/glacier-icon.svg": true,
  "pc/SVG/good.png": true,
  "pc/SVG/guide-map.svg": true,
  "pc/SVG/honor-left-decoration.png": true,
  "pc/SVG/honor-right-decoration.png": true,
  "pc/SVG/icon-list-item.png": true,
  "pc/SVG/left.png": true,
  "pc/SVG/leisure-title.png": true,
  "pc/SVG/logo.svg": true,
  "pc/SVG/menu.svg": true,
  "pc/SVG/more.svg": true,
  "pc/SVG/national-4a-scenic-area.svg": true,
  "pc/SVG/national-geopark.svg": true,
  "pc/SVG/nav-snowflake.svg": true,
  "pc/SVG/notice-watermark@2x-8.png": true,
  "pc/SVG/phone.png": true,
  "pc/SVG/pinned.svg": true,
  "pc/SVG/play-icon.svg": true,
  "pc/SVG/playIcon.png": true,
  "pc/SVG/positioning.png": true,
  "pc/SVG/provincial-scenic-area.svg": true,
  "pc/SVG/recommend.png": true,
  "pc/SVG/report-center-cn.svg": true,
  "pc/SVG/report-center-sc.svg": true,
  "pc/SVG/ribbon-icon.png": true,
  "pc/SVG/right.png": true,
  "pc/SVG/route-recommendation.svg": true,
  "pc/SVG/search-white.svg": true,
  "pc/SVG/sichuan-eco-civilization-base.svg": true,
  "pc/SVG/sichuan-eco-tourism-demo-area.svg": true,
  "pc/SVG/snowflakeLightBlue.svg": true,
  "pc/SVG/specialty-title.png": true,
  "pc/SVG/specialty-title.svg": true,
  "pc/SVG/sub-home-white.svg": true,
  "pc/SVG/sub-home.png": true,
  "pc/SVG/ticket-remaining.svg": true,
  "pc/SVG/time-active.svg": true,
  "pc/SVG/time.svg": true,
  "pc/SVG/top-dropdown.svg": true,
  "pc/SVG/traffic-route.svg": true,
  "pc/SVG/trafficGuide1.png": true,
  "pc/SVG/trafficGuide2.png": true,
  "pc/SVG/trafficGuide3.png": true,
  "pc/SVG/travel-guide-title.png": true,
  "pc/SVG/travel-guide-title.svg": true,
  "pc/SVG/visit-tips.svg": true,
  "pc/SVG/voice-guide.svg": true,
  "pc/SVG/wechat-white.svg": true,
  "pc/SVG/weibo-white.svg": true,
  "pc/SVG/xiaohongshu.svg": true,
  "pc/SVG/休闲娱乐.svg": true,
  "pc/SVG/公告底纹.svg": true,
  "pc/SVG/冬.svg": true,
  "pc/SVG/夏.svg": true,
  "pc/SVG/微信.svg": true,
  "pc/SVG/微博.svg": true,
  "pc/SVG/搜索 蓝色.svg": true,
  "pc/SVG/收起.svg": true,
  "pc/SVG/春.svg": true,
  "pc/SVG/浅色雪花.svg": true,
  "pc/SVG/温馨住宿.svg": true,
  "pc/SVG/游玩攻略.svg": true,
  "pc/SVG/秋.svg": true,
  "pc/SVG/精品线路.png": true,
  "pc/SVG/精品线路.svg": true,
  "pc/SVG/精致特产.svg": true,
  "pc/SVG/返回顶部.svg": true,
  "pc/ticket-booking@2x-8.png": true,
  "pc/traffic-guide.png": true,
  "pc/traffic-guide@2x-8.png": true,
  "pc/travel-guide@2x-8.png": true,
  "pc/tushuo1.png": true,
  "pc/visitor-notice@2x-8.png": true,
  "pc/yxdg/hero@2x-100.jpg": true,
  "pc/yxdg/lQDPKHkH-R1R83_NAfTNA9-wzB5r3y3VvHUJVSP-d0lXAA_991_500.jpg": true,
  "pc/yxdg/resource-10@2x-100.jpg": true,
  "pc/yxdg/resource-11@2x-100.jpg": true,
  "pc/yxdg/resource-12@2x-100.jpg": true,
  "pc/yxdg/resource-13@2x-100.jpg": true,
  "pc/yxdg/resource-14@2x-100.jpg": true,
  "pc/yxdg/resource-15@2x-100.jpg": true,
  "pc/yxdg/resource-2@2x-100.jpg": true,
  "pc/yxdg/resource-3@2x-100.jpg": true,
  "pc/yxdg/resource-4@2x-100.jpg": true,
  "pc/yxdg/resource-5@2x-100.jpg": true,
  "pc/yxdg/resource-6@2x-100.jpg": true,
  "pc/yxdg/resource-7@2x-100.jpg": true,
  "pc/yxdg/resource-8@2x-100.jpg": true,
  "pc/yxdg/resource-9@2x-100.jpg": true,
  "pc/zjdg/banner-text.png": true,
  "pc/zjdg/banner.jpg": true,
  "pc/zjdg/biology.png": true,
  "pc/zjdg/dagu-lake.png": true,
  "pc/zjdg/geology-bg.png": true,
  "pc/zjdg/geology-rt.png": true,
  "pc/zjdg/geology.png": true,
  "pc/zjdg/glacier-experiment.png": true,
  "pc/zjdg/glacier-summit.png": true,
  "pc/zjdg/golden-monkey -sea.png": true,
  "pc/zjdg/honor.png": true,
  "pc/zjdg/intro1.png": true,
  "pc/zjdg/lover's-beach.png": true,
  "pc/zjdg/mount-logos.png": true,
  "pc/zjdg/scientific-research-bg.png": true,
  "pc/zjdg/scientific-research.png": true,
  "pc/zjdg/title-background.png": true,
  "pc/zjdg/zenaco.jpg": true,
  "pc/zwzy/banner-text.png": true,
  "pc/zwzy/banner.jpg": true,
  "pc/zwzy/hero-banner.png": true,
  "pc/zwzy/mailbox-active-bg.png": true,
  "pc/zwzy/mailbox-bg.png": true,
  "pc/zwzy/mailbox-watermark.png": true,
  "pc/zwzy/media-focus-bg.png": true,
  "pc/zwzy/mobile.png": true,
  "pc/zwzy/official-notices-title.png": true,
  "pc/zwzy/pc.png": true,
  "pc/zwzy/procurement-title.png": true,
  "pc/zwzy/scenic-dynamic-title.png": true,
  "pc/zwzy/scenic-dynamic-watermark.png": true,
  "pc/zwzy/title-decor.png": true,
  "pc/回到顶部.svg": true,
} as const;

export type DesignAssetPath = keyof typeof designAssetManifest;
